export const householdNumber = (value?: string | null): string | undefined => {
  if (value && value !== '' && value !== '0') {
    return value
  }
  if (typeof value === 'number' && value === 0) {
    return '1'
  }
  if (value === '0') {
    return '1'
  }
  return undefined
}
